import React from "react";
const prevStorageKey = "letsplaybingo-v4.14.7";
const storageKey = "letsplaybingo-v4.14.8";

/**
 * Checks a defined storage key in localStorage for the
 * property that is passed in and returns the value if it exists
 *
 * @param   {String}  storageKey  [storageKey description]
 * @param   {String}  property    [property description]
 *
 * @return  {Mixed}              [return description]
 */
export function checkCacheForPropertyValue(property) {
  try {
    const cachedSettings = JSON.parse(localStorage.getItem(storageKey));
    let returnValue = null;
    if (cachedSettings) {
      if (Object.keys(cachedSettings).includes(property)) {
        returnValue = cachedSettings[property];
      }
    }
    return returnValue;
  } catch (error) {
    console.warn("Failed to read from localStorage:", error);
    return null;
  }
}

/**
 * Checks the settings for a specific setting
 *
 * @param   {String}  storageKey  [storageKey description]
 * @param   {String}  property    [property description]
 *
 * @return  {Mixed}              [return description]
 */
export function checkCacheForSetting(property) {
  try {
    const cachedSettings = JSON.parse(localStorage.getItem(storageKey)).settings;
    let returnValue = null;
    if (cachedSettings) {
      if (Object.keys(cachedSettings).includes(property)) {
        returnValue = cachedSettings[property];
      }
    }
    return returnValue;
  } catch (error) {
    console.warn("Failed to read setting from localStorage:", error);
    return null;
  }
}

/**
 * Retrieves the cache for the game
 *
 * @return  {Object}
 */
export function getCache() {
  try {
    const cache = localStorage.getItem(storageKey);
    const oldCache = localStorage.getItem(prevStorageKey);
    let parsedCache = null;

    // If new cache doesn't exist but old one does, migrate
    if (cache === null && oldCache !== null) {
      localStorage.setItem(storageKey, oldCache);
      localStorage.removeItem(prevStorageKey);
      parsedCache = JSON.parse(oldCache);
    }
    // If new cache exists but is empty/invalid and old cache has data, use old cache
    else if (cache !== null) {
      parsedCache = JSON.parse(cache);
      // If new cache is empty or missing settings but old cache exists with settings, migrate from old
      if (oldCache !== null && (!parsedCache || !parsedCache.settings)) {
        const parsedOldCache = JSON.parse(oldCache);
        if (parsedOldCache && parsedOldCache.settings) {
          localStorage.setItem(storageKey, oldCache);
          localStorage.removeItem(prevStorageKey);
          parsedCache = parsedOldCache;
        }
      }
    }

    // Migrate old property name callermp3 -> callerMp3
    if (parsedCache && parsedCache.settings && parsedCache.settings.callermp3 !== undefined) {
      parsedCache.settings.callerMp3 = parsedCache.settings.callermp3;
      delete parsedCache.settings.callermp3;
      // Save the migrated cache
      localStorage.setItem(storageKey, JSON.stringify(parsedCache));
    }

    return parsedCache;
  } catch (error) {
    console.warn("Failed to get cache from localStorage:", error);
    return null;
  }
}

/**
 * Updates the cache with the parameter
 *
 * @param   {Object}  state  generally this.state
 */
export function updateCache(state) {
  try {
    localStorage.setItem(storageKey, JSON.stringify(state));
  } catch (error) {
    console.warn("Failed to update cache in localStorage:", error);
  }
}

/**
 * Updates the property in a given localStorage key with the provided value
 *
 * @param   {String}  storageKey  localStorage key
 * @param   {String}  property    name of property (assumes was object)
 * @param   {Mixed}  value        value, could be any object or primitive
 */
export function updateCacheValue(property, value) {
  try {
    let cachedSettings = JSON.parse(localStorage.getItem(storageKey));
    if (cachedSettings === null) {
      cachedSettings = {};
    }
    cachedSettings[property] = value;
    localStorage.setItem(storageKey, JSON.stringify(cachedSettings));
  } catch (error) {
    console.warn("Failed to update cache value in localStorage:", error);
  }
}
